import { render, staticRenderFns } from "./PersonApply.vue?vue&type=template&id=a34ea60c&scoped=true&"
import script from "./PersonApply.vue?vue&type=script&lang=js&"
export * from "./PersonApply.vue?vue&type=script&lang=js&"
import style0 from "./PersonApply.vue?vue&type=style&index=0&id=a34ea60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34ea60c",
  null
  
)

export default component.exports